import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosVal as axios } from "..";

const getDateStr = () => new Date().toISOString();
const initialState = {
    loaded: false,
    isLoggedin: false,
    logout: false,
    generateNew: false,
    savedShiftConf: false,
    shifthChange: null,
    pendingRequests: [],
    shiftRequets: [],
    shift: [],
    nextShift: [],
    dealersForChangeShift: [],
    hasCheckedDealers: false,
    user: {},
    repleacedShift: {},
    addedUserDate: getDateStr(),
    userAccount: {},
    searchResults: [],
    shiftUpdated: false,
    accountUpdated: false,
    accountDeleted: false,
    error: {
        status: false,
        message: ""
    },
    success: {
        status: false,
        message: ""
    },
};

const getToken = () => "LiveBearer " + localStorage.getItem('auth-token');

export const generateShift = createAsyncThunk('shifts/generate', async (data) => {
    try {
        const response = await axios.post(
            "/shifts/generate",
            {
                ...data
            },
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
});

export const shiftDelete = createAsyncThunk('shifts/delete', async (shiftId) => {
    try {
        const response = await axios.delete(
            `/shifts/${shiftId}`,
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
});

export const getShiftHistory = createAsyncThunk('shifts/history', async () => {
    try {
        const response = await axios.get(
            "/shifts/history",
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
});

export const generationData = createAsyncThunk('shifts/generationData', async (generation) => {
    try {
        const response = await axios.get(
            "/shifts/"+generation,
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
});

export const getCurrentShift = createAsyncThunk('shifts/getCurrentShift', async () => {
    try {
        const response = await axios.get(
            "/shifts/currentGeneration",
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
});

export const getNextShift = createAsyncThunk('shifts/getNextShift', async () => {
    try {
        const response = await axios.get(
            "/shifts/nextGeneration",
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
});

export const addDealerToShift = createAsyncThunk('shifts/addDealerToShift', async (data) => {
    try {
        const response = await axios.post(
            "/shifts/addDealer",
            {...data},
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
});

export const saveShift = createAsyncThunk('shifts/saveShift', async (generation) => {
    try {
        const response = await axios.post(
            "/shifts/saveShift",
            {generation},
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
});

export const sendNotification = createAsyncThunk('shifts/sendNotification', async (generation) => {
    try {
        const response = await axios.post(
            "/shifts/sendNotification",
            {generation},
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
});

export const removeDealerFromShift = createAsyncThunk(
    'shifts/removeDealerFromShift',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                "/shifts/removeDealer",
                {
                    data: { ...data } // Send data in the request body for DELETE
                },
                {
                    headers: {
                        'x-auth': getToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const dealerChnageShift = createAsyncThunk(
    'shifts/dealerChangeShift',
    async (shift, { rejectWithValue }) => {
        console.log("dealer Chnage Shift ", shift)
        try {
            const response = await axios.put(
                "/shifts/dealerChangeShift",
                shift,
                {
                    headers: {
                        'x-auth': getToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            //a
            throw error
        }
    }
);

export const checkFreeDealers = createAsyncThunk(
    'requests/checkFreeDealers',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                "/requests/checkFreeDealers",
                data,
                {
                    headers: {
                        'x-auth': getToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.log("error.response ", error.response)
            return rejectWithValue({
                status: error.response.status,
                message: error.response.data?.message,
                data: error.response.data // Include full response if needed
            });
        }
    }
);

export const sendShiftChnageRequest = createAsyncThunk(
    'requests/sendShiftChnageRequest',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                "/requests/sendShiftChnageRequest",
                data,
                {
                    headers: {
                        'x-auth': getToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.log("error.response ", error.response)
            return rejectWithValue({
                status: error.response.status,
                message: error.response.data?.message,
                data: error.response.data // Include full response if needed
            });
        }
    }
);

export const pendingShiftRequestsHistory = createAsyncThunk(
    'requests/pendingShiftRequestsHistory',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                "/requests/pendingShiftRequestsHistory",
                {
                    headers: {
                        'x-auth': getToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.log("error.response ", error.response)
            return rejectWithValue({
                status: error.response.status,
                message: error.response.data?.message,
                data: error.response.data // Include full response if needed
            });
        }
    }
);

export const getReplacedData = createAsyncThunk(
    'shifts/getReplacedData',
    async (shift, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                "/shifts/getReplacedData",
                shift,
                {
                    headers: {
                        'x-auth': getToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.log("error.response ", error.response)
            return rejectWithValue({
                status: error.response.status,
                message: error.response.data?.message,
                data: error.response.data // Include full response if needed
            });
        }
    }
);

export const cancelShiftRequest = createAsyncThunk(
    'requests/cancelShiftRequest',
    async (requestId, { rejectWithValue }) => {
      try {
        await axios.delete(
          `/requests/changeRequest/${requestId}`,
          {
            headers: {
              'x-auth': getToken(),
            },
          }
        );
        return { id: requestId };
      } catch (error) {
        console.log("Errror ", error)
        return rejectWithValue({
          status: error.response?.status,
          message: error.response?.data?.message || "Failed to cancel request",
        });
      }
    }
  );
  

export const getAllShiftRequets = createAsyncThunk(
    'requests/getAllShiftRequets',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                "/requests/getAllShiftRequets",
                {
                    headers: {
                        'x-auth': getToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.log("error.response ", error.response)
            return rejectWithValue({
                status: error.response.status,
                message: error.response.data?.message,
                data: error.response.data // Include full response if needed
            });
        }
    }
);

const shiftsSlice = createSlice({
    name: "studios",
    initialState,
    reducers: {
        reset(state) {
            state.error.status = false;
            state.success.status = false;
            state.generateNew = false;
            state.dealersForChangeShift = [];
        },
        resetCheckDealers(state) {
            state.hasCheckedDealers = false;
            state.dealersForChangeShift = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(generateShift.fulfilled, (state, action) => {
            state.shift = action?.payload;
            state.generateNew = true;
        });
        builder.addCase(generateShift.pending, (state, action) => {
            state.savedShiftConf = false;
        }); 
        builder.addCase(addDealerToShift.fulfilled, (state, action) => {
            state.shift = action?.payload;
            state.addedUserDate = getDateStr();
        }); 
        builder.addCase(generationData.fulfilled, (state, action) => {
            state.shift = action?.payload;
        });
        builder.addCase(getCurrentShift.fulfilled, (state, action) => {
            state.shift = action?.payload;
        });
        builder.addCase(getNextShift.fulfilled, (state, action) => {
            state.nextShift = action?.payload;
        });
        builder.addCase(removeDealerFromShift.fulfilled, (state, action) => {
            state.shift = action?.payload;
        });
        builder.addCase(saveShift.fulfilled, (state, action) => {
            state.saveDate = getDateStr();
            state.success.status = true;
            state.savedShiftConf = action.payload;
            state.success.message = "Shift saved successfully";
        });
        builder.addCase(saveShift.pending, (state, action) => {
            state.success.status = false;
            state.error.status = false;
        });
        builder.addCase(sendNotification.fulfilled, (state, action) => {
            state.saveDate = getDateStr();
            state.success.status = true;
            state.success.message = "You have successfully sent the notification";
        });
        builder.addCase(getShiftHistory.fulfilled, (state, action) => {
            state.history = action.payload
        });
        builder.addCase(shiftDelete.fulfilled, (state, action) => {
            const deletedId = action.payload;
            state.history.shiftConf = state.history.shiftConf.filter(conf => conf.id !== deletedId);
        });
        builder.addCase(dealerChnageShift.fulfilled, (state, action) => {
            console.log("aaa")
        });
        builder.addCase(checkFreeDealers.pending, (state, action) => {
            state.error.status = false;
            state.success.status = false;
            state.hasCheckedDealers = false;
        });
        builder.addCase(checkFreeDealers.rejected, (state, action) => {
            state.error.status = true;
            state.success.status = false;
            
            state.error.message = action.payload.message;
        });
        builder.addCase(checkFreeDealers.fulfilled, (state, action) => {
            state.error.status = false;
            state.success.status = true;
            state.hasCheckedDealers = true;
            state.dealersForChangeShift = action.payload
        });
        builder.addCase(sendShiftChnageRequest.pending, (state, action) => {
           
        });
        builder.addCase(sendShiftChnageRequest.rejected, (state, action) => {
          
        });
        builder.addCase(sendShiftChnageRequest.fulfilled, (state, action) => {
            state.shifthChange = new Date()
        });
        builder.addCase(pendingShiftRequestsHistory.pending, (state, action) => {
           
        });
        builder.addCase(pendingShiftRequestsHistory.rejected, (state, action) => {
            console.log("shiftRequestsHistory Rejected")
        });
        builder.addCase(pendingShiftRequestsHistory.fulfilled, (state, action) => {
            state.pendingRequests = action.payload;
        });
       builder.addCase(getAllShiftRequets.fulfilled, (state, action) => {
            state.shiftRequets = action.payload;
        });
        builder.addCase(cancelShiftRequest.fulfilled, (state, action) => {
            state.shiftUpdated = new Date();
        });
        builder.addCase(getReplacedData.fulfilled, (state, action) => {
            state.repleacedShift = action.payload
        });
        builder.addCase(getReplacedData.pending, (state, action) => {
            state.repleacedShift = {}
        });
       
    }
});

export const shiftActions = shiftsSlice.actions;
export const shiftReducer = shiftsSlice.reducer;
